const c = {
  name: "CommercialOperationsTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22.5,7V0h-2v3.7c-1.2-1.2-2.7-2.1-4.3-2.6C13.9,0.3,11.4,0.3,9.1,1C6.7,1.8,4.7,3.2,3.2,5.2
			C1.8,7.2,1,9.6,1,12l2,0c0-2,0.6-4,1.8-5.6C6,4.7,7.7,3.5,9.7,2.9c1.9-0.6,4-0.6,5.9,0.1c1.3,0.4,2.4,1.1,3.4,2h-3.4v2H22.5z"/>
		<path class="st0" d="M13.5,7v2.2c0.1,0,0.2,0.1,0.3,0.1l1.5-1.5l1.4,1.4l-1.5,1.5c0,0.1,0.1,0.2,0.1,0.3h2.2v2h-2.2
			c0,0.1-0.1,0.2-0.1,0.3l1.5,1.5l-1.4,1.4l-1.5-1.5c-0.1,0-0.2,0.1-0.3,0.1V17h-2v-2.2c-0.1,0-0.2-0.1-0.3-0.1l-1.5,1.5l-1.4-1.4
			l1.5-1.5c0-0.1-0.1-0.2-0.1-0.3H7.5v-2h2.2c0-0.1,0.1-0.2,0.1-0.3L8.3,9.2l1.4-1.4l1.5,1.5c0.1,0,0.2-0.1,0.3-0.1V7H13.5z
			 M11.7,11.4c-0.1,0.2-0.2,0.4-0.2,0.6s0.1,0.5,0.2,0.6l0.2,0.2c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.5-0.1,0.6-0.2l0.2-0.2
			c0.1-0.2,0.2-0.4,0.2-0.6s-0.1-0.5-0.2-0.6l-0.2-0.2C13,11.1,12.7,11,12.5,11c-0.2,0-0.5,0.1-0.6,0.2L11.7,11.4z"/>
		<path class="st0" d="M2.5,17h7v2H6.1c1,0.9,2.1,1.6,3.4,2c1.9,0.7,4,0.7,5.9,0.1c1.9-0.6,3.6-1.8,4.8-3.4C21.4,16,22,14,22,12l2,0
			c0,2.4-0.8,4.8-2.2,6.8s-3.5,3.4-5.8,4.2c-2.3,0.7-4.8,0.7-7.2-0.1c-1.6-0.6-3.1-1.4-4.3-2.6V24h-2V17z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as CommercialOperationsTeam
};
